import React from 'react';
import c from 'classnames';

// This component renders a step based on all the pages
// And the current page.
var WebformStepCounter = function WebformStepCounter(_ref) {
  var pages = _ref.pages,
    currentPage = _ref.currentPage;
  // If there are no pages
  // or a current page, return.
  if (!pages || !currentPage) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "WebformStepCounter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "WebformStepCounter__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "WebformStepCounter__line"
  }), pages.map(function (item, key) {
    // Get the index of the current page in the original
    // array, so we can compare it to the key of the
    // currently mapped item.
    var currentIndex = pages.findIndex(function (x) {
      return x === currentPage;
    });
    var WebformStepInnerClasses = c('WebformStepCounter__step__inner', {
      'WebformStepCounter__step--active': currentPage === item,
      'WebformStepCounter__step--completed': currentIndex > key
    });
    return /*#__PURE__*/React.createElement("div", {
      key: "WebformStepCounter__Step--".concat(item),
      className: "WebformStepCounter__step"
    }, /*#__PURE__*/React.createElement("div", {
      className: WebformStepInnerClasses
    }, key + 1));
  })));
};
export default WebformStepCounter;